module.exports = __webpack_public_path__ + "static/media/remove-acc.58934a47.svg";